'use client'
import Toggle from '@/components/toggle'
import { SearchTypeContext } from '@/context/search-type'
import { useFormatCopy } from '@/context/site-chrome-copy'
import UAParserContext from '@/context/ua-parser'
import { trackPageView } from '@/util/analytics'
import { useRouter, useSearchParams } from 'next/navigation'
import { useContext } from 'react'
import { SearchType } from '../types'
import { cn } from '@/util/cn'

export const useGetPathname = (route: string, term: string, type: SearchType): string => {
    const search = useSearchParams()
    const searchParams = search.toString()
    const gifUrl = `${term
        .replace(/stickers|sticker|transparent|clips/gi, '')
        .trim()
        .replace(/\s+/g, '-')}`
    return `${route}/${gifUrl}${type === 'gifs' ? `` : `-${type}`}${searchParams ? `?${searchParams}` : ''}`
}

type Props = {
    className?: string
    initialSearchTerm: string
    routerType: SearchType
    targetPage?: 'search' | 'explore'
}

const SearchToggle = ({ initialSearchTerm, routerType, className, targetPage = 'search' }: Props) => {
    const router = useRouter()
    const { isBot } = useContext(UAParserContext)
    const { setTransitioning } = useContext(SearchTypeContext)
    const formats = useFormatCopy()
    const targetPageToUse = isBot ? 'explore' : targetPage
    const contentTypes = ['gifs', 'stickers', 'clips'] as const
    const hrefGifs = useGetPathname(`/${targetPageToUse}`, initialSearchTerm, 'gifs')
    const hrefStickers = useGetPathname(`/${targetPageToUse}`, initialSearchTerm, 'stickers')
    const hrefClips = useGetPathname(`/${targetPageToUse}`, initialSearchTerm, 'clips')
    const options = [
        { label: formats.gifs, href: hrefGifs },
        { label: formats.stickers, href: hrefStickers },
        { label: formats.clips, href: hrefClips },
    ]

    const searchToggleClassName = cn('w-full md:w-[400px]', className)

    return (
        <div className="mb-2 w-full md:w-[400px]">
            <Toggle
                onClick={(index) => {
                    const nextType = contentTypes[index]
                    const nextPathname =
                        nextType === 'gifs' ? hrefGifs : nextType === 'stickers' ? hrefStickers : hrefClips
                    router.replace(nextPathname)
                    setTimeout(() => {
                        trackPageView(nextPathname)
                    }, 50)
                    setTransitioning(true)
                }}
                options={options}
                className={searchToggleClassName}
                index={contentTypes.indexOf(routerType)}
            />
        </div>
    )
}
export default SearchToggle
